import { map, type OperatorFunction } from 'rxjs';

import { type ApiResponse } from '../types';

export function mapList<TDto, T = TDto>(mapper?: (dto: TDto) => T): OperatorFunction<ApiResponse<TDto[]>, T[]> {
  return map((response) => {
    const data = response.data ?? [];
    return mapper ? data.map(mapper) : (data as unknown as T[]);
  });
}
